let updateCounter = [];
let oldValuesStore = {};

export default {
  changeValue({ commit, rootState }, payload) {
    if (!updateCounter.includes(payload.name)) {
      if (typeof payload.oldValue === "object") {
        oldValuesStore[payload.name] = JSON.parse(JSON.stringify(payload.oldValue));
      } else {
        oldValuesStore[payload.name] = payload.oldValue?.valueOf() ?? payload.oldValue;
      }
      updateCounter.push(payload.name);
    }
    payload.oldValue = oldValuesStore[payload.name];

    // insert Extra Param
    payload.teamId = rootState.window.team_id;
    // insert Extra Param

    if (
      (Array.isArray(payload.oldValue) && Array.isArray(payload.newValue)) ||
      (typeof payload.oldValue === "object" && typeof payload.newValue === "object")
    ) {
      if (JSON.stringify(payload.oldValue) !== JSON.stringify(payload.newValue)) {
        commit("setChanged", payload);
      } else {
        commit("removeChanged", payload);
      }
      return;
    }
    if (payload.oldValue !== payload.newValue || payload.change) {
      commit("setChanged", payload);
    } else {
      commit("removeChanged", payload);
    }
  },
  setInitial({ commit }) {
    commit("setInitial", {});
    oldValuesStore = {};
    updateCounter = [];
  },
};
